/** @format */
// eslint-disable-next-line check-file/filename-naming-convention -- Legacy code: do not use as an example.
import { css } from 'styled-components';

import { StyledContainerProps } from './index';

/** @format */

export const baseStyles = css`
    position: relative;
    display: inline-flex;
    align-items: center;
`;

/**
 * Styles for when we want the select inline container
 * to fill its parent container
 *
 * @param {SelectProps}  props - The select properties object
 * @param {boolean}      props.fillParent - Whether or not to fill parent
 * */
export const fillParentStyles = ({ fillParent }: StyledContainerProps) => {
    if (fillParent) {
        return css`
            width: 100%;
            height: 100%;
            justify-content: center;
        `;
    }

    return css``;
};

/**
 * Styles for when we want the select inline container
 * to fill its parent container
 *
 * @param {SelectProps}  props - The select properties object
 * */
export const displayArrowStyles = ({ displayArrow }: StyledContainerProps) => {
    if (displayArrow) {
        /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
        return css`
            padding-right: 2.4rem;
        `;
        /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    }

    return css``;
};

/**
 * The inline container component styles
 *
 * @param {SelectProps} props - The select properties object
 */
export const styles = (props: StyledContainerProps) => {
    return css`
        ${baseStyles}
        ${fillParentStyles(props)}
        ${displayArrowStyles(props)}
    `;
};
